import React from "react";
import { useQuery } from "react-query";

import { Box, Link, Stack, Typography } from "@mui/joy";

import { FileApi } from "../../api/file";
import { PrimeQueryKeys } from "../../shared/constants";

import FragmentNodePreviewImage from "../FragmentNodePreviewImage";
import { ApiFragmentNode } from "../../shared/interfaces";
import { FileViewerArgs } from "../fileviewer/FileViewer";
import { NodeTitle } from "../nodes/NodeTitle";

const styles = {
    filePreview: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 2,
        borderRadius: "sm",
    },
};

export function ProblemNode({
    node,
    setCurrentFileViewerFile,
}: {
    node: ApiFragmentNode;
    setCurrentFileViewerFile: (args: FileViewerArgs | null) => void;
}) {
    const { data: file } = useQuery(PrimeQueryKeys.file(node.fileId), () =>
        FileApi.getFile(node.fileId),
    );

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const fileViewerArgs: FileViewerArgs = {
            file: file!,
            referenceHighlights: [node.bounds],
            scrollToFragmentNode: node,
        };
        setCurrentFileViewerFile(fileViewerArgs);
    };

    return (
        <Link onClick={handleClick} color="neutral" variant="plain" sx={styles.filePreview}>
            <Stack spacing={1}>
                <Typography>
                    <NodeTitle node={node} includeDocumentType={true} />
                </Typography>

                <Box className="fragmentPreview">
                    <FragmentNodePreviewImage node={node} />
                </Box>
            </Stack>
        </Link>
    );
}
